import { DatePipe } from '@angular/common';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ActivityTabs, buttonTypes, ComponentTypes, PartyState } from 'src/app/shared/constants/commonenums';
import { ButtonValue } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { OperationResultState } from 'src/app/shared/Models/ResultModels';
import { BookingActivity, ClassType, SessionBookingDTO } from 'src/app/shared/Models/SessionBookingDTO';
import { operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { PopupService } from 'src/app/shared/services/popup.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { ActivitiesService } from '../activities.service';
import { RatePlanDetailsComponent } from '../rate-plan-details/rate-plan-details.component';
import { FinancialEffectType, PartyPrepaymentState } from 'src/app/shared/Models/PartyModels';
import { FormatSettingsDatePipe } from '../../shared/pipes/format-settings-date.pipe'
@Component({
    selector: 'app-activity-booking-summary',
    templateUrl: './activity-booking-summary.component.html',
    styleUrls: ['./activity-booking-summary.component.scss'],
    standalone: false
})
export class ActivityBookingSummaryComponent extends Utilities implements OnInit, AfterViewInit, OnDestroy {
  modifyBtn: ButtonValue;
  cancelBtn: ButtonValue;
  backToCartSummarybtn: ButtonValue;
  BookAnotherReservationBtn: ButtonValue;
  additionalGuestBtn: ButtonValue;
  ratePlan: any;
  isSessionClass: boolean;
  showAllSlots: boolean;
  Instructors: string;
  Locations: string;
  lessonName: string;
  Subscriptions: Subscription = new Subscription;
  ConfirmationData: any;
  classDetail: any;
  SessionCount = 0;
  TotalAmount = 0;
  OperationCurrency: any;
  cancelDialogRef: MatDialogRef<any>;
  reservationCancelled = false;
  sessionIds = [];
  subscriptions: Subscription = new Subscription();
  showScheduleSummary = true;
  CoverTypeQuantities: any = [];
  BookingTypeQuantities: any = [];
  bookingSection: boolean;
  coverSize: string;
  openBookingStartDate: any;
  ratePlanList: any;
  PartyState = PartyState;
  PartyPrepaymentState = PartyPrepaymentState;
  SeatedType: any = '';
  constructor(public ts: TranslateService, private ps: PopupService, public activityService: GuestService, public dialog: MatDialog, private datePipe: DatePipe , public dateFormat: FormatSettingsDatePipe) {
    super(dialog);
    this.bookingSection = this.activityService.bookingSection$.value;

    this.Subscriptions.add(
      this.activityService.RatePlanList$.subscribe(data => {
        this.ratePlan = data;
        if (data) {
          this.ratePlanList = data.SlotList ? data.SlotList[0] : data.RatePlanCalculations ? data.RatePlanCalculations : data;
          this.calculateTotalAmount();
        }
      })
    );

    this.Subscriptions.add(
      this.activityService.editPartyData$.subscribe(data => {
        if (data && data.Id) {
          this.showScheduleSummary = true;
          if (data.State === PartyState.Seated || data.State === PartyState.Cancelled || data.State === PartyState.Left) {
            this.SeatedType = PartyState[data.State];
          }

          this.ConfirmationData = data;
          this.CoverTypeQuantities = data.CoverTypeQuantities;
          this.BookingTypeQuantities = data.BookingTypeQuantities;
          this.classDetail = data.SpecialMeal;
          this.lessonName = this.classDetail ? (this.classDetail.Name ? this.classDetail.Name : "") : "";
          this.coverSize = data.Size;
          if (data.StartDate) {
            this.openBookingStartDate = data.ReservedFor;
          }
          this.getLocations();
          this.getInstructors();
          if (this.ConfirmationData?.DepositPaid) {
            this.calculateTotalAmount();
          }
          this.isSessionClass = !this.ConfirmationData.SessionGroupId ? true : false;
          if (this.isSessionClass) {
            this.SessionCount = this.ConfirmationData.BookedSessions?.length;
          }
        }
      }));
  }

  calculateTotalAmount() {
    if (this.ConfirmationData?.PrepaymentState === PartyPrepaymentState?.DepositCollected) {
      this.TotalAmount = Number(this.ratePlan?.TotalRatePlan) - (this.ConfirmationData?.DepositPaid ? Number(this.ConfirmationData?.DepositPaid) : 0);
    } else {
      this.TotalAmount = Number(this.ratePlan?.TotalRatePlan);
    }
  }


  ngOnInit(): void {
    this.cancelBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('cancel'),
      customclass: 'reservation-confirmation__cancel-reservation',
    };

    this.modifyBtn = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('modify'),
      customclass: 'reservation-confirmation__modify-details',
    };
    this.BookAnotherReservationBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('bookAnotherReservation'),
      customclass: 'reservation-confirmation__cancel-reservation',
    };

    this.backToCartSummarybtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('BackToCartSummary'),
      customclass: 'reservation-confirmation__cancel-reservation',
    };

    this.OperationCurrency = this.activityService.restaurantWidgetSettings$.value.OperationCurrency;

  }
  additionalGuest(eve) {
    this.activityService.TabChange$.next(ActivityTabs.ActivitySelection);
  }

  setPartiesData(data) {
    data.forEach(party => {

    });
  }

  ngAfterViewInit() {
    this.subscriptions.add(this.ps.actionEnabled$.subscribe(x => {
      if (x == ComponentTypes.cancelReservation) {
        this.cancelDialogRef.close();
        this.confirmCancelation();
      }
    }));

    this.subscriptions.add(this.ps.cancelEnabled$.subscribe(x => {
      if (x == ComponentTypes.cancelReservation) {
        this.activityService.operation = operationType.edit;
        this.activityService.reservationConfirmationText = this.ts.instant('reservationDetainedConfirmationText');
      }
    }));
  }

  bookAnotherReservationBtn(event) {
    this.activityService.setMessageState('', 0);
    this.activityService.SaveBookingObj = null;
    this.activityService.SessionBookingObj = {} as SessionBookingDTO;
    this.activityService.slots_holder = [];
    this.activityService.selectedOpenBookingSlots = {};
    this.activityService.operation = operationType.create;
    this.activityService.TabChange$.next(ActivityTabs.BookingSelection);
    this.activityService.BookNew$.next(true);
    this.activityService.bookingSection$.next(BookingActivity.ClassBooking);
    this.activityService.RatePlanList$.next(null);
    this.isSessionClass = false;
    this.reservationCancelled = false;
    this.showScheduleSummary = true;
    this.activityService.ispaymentInvolvedInfo = null;
    this.activityService.reservationAttemptInfo = null;
    this.activityService.additionalGuestPage = false;
    this.activityService.additionalGuestRequired = 0;
    this.activityService.slotLockId = 0;
    this.activityService.RefundAmount = 0;
    this.activityService.TotalRefundAmount = 0;
    this.activityService.lockResult = null;
    this.activityService.reservationToken = null;
    this.activityService.bookingPartiesData$.next(null);
    const SaveContact = this.activityService.editPartyData$.value.Contact;
    this.activityService.editPartyData$.next({
      Contact: SaveContact
    })
    this.activityService.BookAnotherReservation.next(true);
  }

  showratePlanDetails() {
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(RatePlanDetailsComponent, 'small', '', '',
      this.ts.instant('rates'));
    this.openCustomPopup(componentDetails, ComponentTypes.informationPopup, '450px', '300px', true, 'No', 'Ok',
      null, true)
  }

  getInstructors() {
    let SelectedStaffList = '';
    this.ConfirmationData.StaffId?.forEach((staff, index) => {
      const selectedStaff = this.activityService.InstructorList.filter(data => data.Id === staff)[0];
      if (selectedStaff) {
        SelectedStaffList = SelectedStaffList + (selectedStaff.Name + (selectedStaff.LastName || ''));
      }
      if (index !== this.ConfirmationData.StaffId?.length - 1) {
        SelectedStaffList = SelectedStaffList + ', ';
      }
    });
    this.Instructors = SelectedStaffList;
  }

  getLocations() {
    let SelectedLocationList = '';
    this.ConfirmationData.TableIds?.forEach((location, index) => {
      const selectedLoc = this.activityService.LocationList.filter(data => data.Id === location)[0];
      SelectedLocationList = SelectedLocationList + (selectedLoc.Name);

      if (index !== this.ConfirmationData.TableIds?.length - 1) {
        SelectedLocationList = SelectedLocationList + ', ';
      }
    });
    this.Locations = SelectedLocationList;
  }


  modifyDetails(event) {
    this.activityService.operation = operationType.edit;
    this.activityService.TabChange$.next(ActivityTabs.BookingSelection);
  }

  cancelReservationList(ids) {
    console.log(ids)
    this.sessionIds = ids;
  }

  cancelDetails(event) {
    const datePipeString = this.dateFormat.transform(new Date(this.activityService.editPartyData$.value.ReservedFor) , this.activityService.restaurantWidgetSettings$.value.DateFormat);
    this.ts.get('AskCancelReservationConfirmation', { date: datePipeString, locationName: this.activityService.restaurantWidgetSettings$.value.RestaurantName }).subscribe(text => {
      const popUpMessage = [{
        confirmationMessage: text,
        dialogTitle: this.ts.instant('cancelActivity'),
        showAlert: true
      }];
      const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
        popUpMessage[0].dialogTitle);
      this.cancelDialogRef = this.openCustomPopup(componentDetails, ComponentTypes.cancelReservation, '450px', '300px', true, '', this.ts.instant('Yes'),
        this.ts.instant('No'), true)
    })
  }

  confirmCancelation() {
    this.activityService.CancelBooking(this.activityService.restaurantWidgetSettings$.value.RestaurantId, this.activityService.editPartyData$.value.Id, this.activityService.language, this.sessionIds).subscribe(data => {
      if (data.State == OperationResultState.Success) {
        this.activityService.reservationConfirmationText = this.ts.instant('reservationCancellationConfirmationText')
        this.activityService.setMessageState(this.ts.instant('reservationCancellationText'), 0);
        this.reservationCancelled = true;
      }
    });
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  reservationStatus(event) {
  }


  showSchedule(event) {
    this.showScheduleSummary = false;
    this.reservationCancelled = true;
  }

  backToCartSummary(event) {
    this.activityService.setMessageState('', 0);
    this.showScheduleSummary = true;
    this.reservationCancelled = false;
    this.activityService.TabChange$.next(ActivityTabs.CartDetails);
  }
}
